import React from "react";
import { Tag } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { Task } from "~/types/task";

interface DispatchNoteBannerProps {
  notes: Task[];
  variant?: "full" | "compact";
}

export const DispatchNoteBanner: React.FC<DispatchNoteBannerProps> = ({
  notes,
  variant = "full",
}) => {
  if (!notes || notes.length === 0) return null;

  if (variant === "compact") {
    return (
      <>
        {notes.map((note) => (
          <div
            key={note.id}
            className="bg-indigo-50 border border-indigo-200 rounded p-2 mb-1"
          >
            <div className="flex items-center gap-1 text-xs mb-0.5">
              <FileTextOutlined className="text-indigo-500" />
              <span className="font-semibold text-indigo-700 truncate">
                {note.title}
              </span>
            </div>
            {note.description && (
              <p className="text-xs text-gray-600 whitespace-pre-wrap line-clamp-3 ml-4">
                {note.description}
              </p>
            )}
          </div>
        ))}
      </>
    );
  }

  return (
    <>
      {notes.map((note) => (
        <div
          key={note.id}
          className="bg-indigo-50 border border-indigo-200 rounded-lg p-3 mb-3"
        >
          <div className="flex items-start gap-2">
            <FileTextOutlined className="text-indigo-500 mt-0.5" />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="font-semibold text-sm text-gray-900">
                  {note.title}
                </span>
                <Tag color="purple" className="text-xs">
                  Dispatch Note
                </Tag>
              </div>
              {note.description && (
                <p className="text-xs text-gray-600 mt-1 whitespace-pre-wrap line-clamp-3">
                  {note.description}
                </p>
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
